import React from 'react';

export const getError = error => {
  const networkError = (error && error.networkError) || undefined;
  const errorMessage =
    networkError && networkError.result
      ? networkError.result
      : 'There was an error';
  const errorStatus =
    networkError && networkError.statusCode
      ? networkError.statusCode
      : undefined;
  return { errorMessage, errorStatus };
};

export const getErrorMessageText = errorMessage => {
  let errorMessageText = errorMessage || 'There was an error.';
  let messagesCount = 0;
  if (errorMessage === Object(errorMessage)) {
    errorMessageText = Object.keys(errorMessage).map(errorKey => {
      const errorKeyText = errorKey
        .replace('_', ' ')
        .replace(/^\w/, c => c.toUpperCase());
      if (Array.isArray(errorMessage[errorKey])) {
        return errorMessage[errorKey].map(errorMsg => {
          messagesCount += 1;
          return (
            <span
              key={errorKeyText}
              style={messagesCount > 1 ? { display: 'block' } : {}}
            >
              {`${errorKeyText}: ${errorMsg}`}
            </span>
          );
        });
      }
      if (typeof errorMessage[errorKey] === 'object') {
        return Object.keys(errorMessage[errorKey]).map(errorMsg => {
          messagesCount += 1;
          return (
            <span
              key={errorKeyText}
              style={messagesCount > 1 ? { display: 'block' } : {}}
            >
              {`${errorKeyText}: ${errorMsg}`}
            </span>
          );
        });
      }
      return `${errorKeyText}: ${errorMessage[errorKey]}`;
    });
  }
  return errorMessageText;
};
